/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentEditor } from "@tiptap/react";
import { useState } from "react";
import debounce from "lodash.debounce";
import { Logger } from "cms/utils/log/logger";

const useSelectedText = () => {
    
    const { editor } = useCurrentEditor();
    // const [selection,setSelection] = useState(editor?.view?.state?.selection)
    const [selectedText,setSelectedText] = useState(editor?.view?.state?.selection?.node?.text);
    const findSelection = debounce(() => {
        if (!editor) {
            return;
        }
        const { from, to, empty } = editor.state.selection;
        if (empty) {
            return;
        }
        const selectionText = editor.state.doc.textBetween(from, to, " ");
        Logger.debug(selectionText);
        setSelectedText(selectionText);
    }, 900);
    
    return {
        selectedText,
        findSelection,
    };
};

export { useSelectedText };
